/**
 * UserMessage — rechtsbündige User-Bubble (#1180).
 */
import { Paperclip } from 'lucide-react';

export default function UserMessage({ text, attachments }) {
  return (
    <div className="flex justify-end mb-4">
      <div className="max-w-[80%] bg-[#338edc] text-white rounded-2xl rounded-tr-sm px-4 py-2.5 shadow-sm">
        <div className="whitespace-pre-wrap break-words text-[14px] leading-relaxed">{text}</div>
        {Array.isArray(attachments) && attachments.length > 0 && (
          <div className="mt-2 pt-2 border-t border-white/20 space-y-1">
            {attachments.map((a, i) => (
              <div key={a.id || i} className="flex items-center gap-1.5 text-xs text-white/90">
                <Paperclip size={12} />
                <span className="truncate">{a.filename || a.name || `attachment-${i + 1}`}</span>
                {a.size != null && <span className="opacity-70">· {Math.round(a.size / 1024)} KB</span>}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
